export enum CategoryType {
  Standard = 'Standard',
  Cocktail = 'Cocktail'
}
